import { isArsMasterReadDto } from "functions/api/tlfItem/TlfItemReadDto";
import { ITlfActionRenameVariantPatch, TlfContextProps, UPDATE_TLF } from "./interface";
import { tlf_updateTlf } from "./tlf_updateTlf";
import { updateVariantPatchSelection } from "./updateVariantPatchSelection";

/**
 * Renames a catalogue patch and updates template, applied and active references.
 *
 * @param state - Current TLF context state, including pending active patch edits
 * @param action - Existing patch name and requested replacement name
 * @returns Updated state with undo history, or unchanged state for an invalid rename
 */
export const tlf_renameVariantPatch = (
  state: TlfContextProps,
  action: ITlfActionRenameVariantPatch,
): TlfContextProps => {
  const newPatchName = action.newPatchName.trim();
  if (state.readOnly || !isArsMasterReadDto(state.tlfData)) return state;
  const current = state.tlfData;
  if (
    newPatchName === "" ||
    !Object.hasOwn(current.allVariantPatches, action.patchName) ||
    Object.hasOwn(current.allVariantPatches, newPatchName)
  )
    return state;

  const newState = tlf_updateTlf(state, {
    operation: UPDATE_TLF,
    calledFrom: action.calledFrom,
    tlfData: {
      allVariantPatches: Object.fromEntries(
        Object.entries(current.allVariantPatches).map(([name, patch]) => [
          name === action.patchName ? newPatchName : name,
          patch,
        ]),
      ),
      variantTemplates: current.variantTemplates.map((template) => ({
        ...template,
        variantPatches: template.variantPatches.map((name) =>
          name === action.patchName ? newPatchName : name,
        ),
      })),
    },
  });
  return updateVariantPatchSelection(
    newState,
    state.appliedVariantPatches.map((name) => (name === action.patchName ? newPatchName : name)),
    state.activeVariantPatchName === action.patchName ? newPatchName : state.activeVariantPatchName,
  );
};
